// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithoutRef } from 'react';
import { S } from './style';
import ErrorImg from '../../assets/images/pic_error_internet.svg';
import { FormattedMessage } from 'react-intl';
import { BIFROST_URL } from '../../configuration';

export type errorType = 'Bitfrost' | 'undefined';

interface ErrorPageProps extends React.ComponentPropsWithoutRef<'div'>{
  errorType?: errorType;
}

function ErrorPage({...props}: ErrorPageProps): JSX.Element {
  const retry = () => {
    switch (props.errorType) {
      case 'Bitfrost':
        window.location.href = BIFROST_URL;
        break;
      default :
        window.location.reload();
        break;
    }
  }

  const errorMessage = {
    'Bitfrost': 'J064',
    'undefined': 'B031'
  }
  const errorRetryMessage = {
    'Bitfrost': 'J064-1',
    'undefined': 'B031-1'
  }
  const errorRedirectURL = {
    'Bitfrost': BIFROST_URL,
    'undefined': '/home'
  }
  const errorRedirectButtonName = {
    'Bitfrost': 'B059',
    'undefined': 'B032'
  }
  return (
    <S.Container alignX="center" alignY="center" {...props}>
      <S.Img src={ErrorImg} alt="" />
      <S.P>
        <FormattedMessage id={props.errorType? errorMessage[props.errorType] :'B031'} values={{here: <S.Retry onClick={retry}><FormattedMessage id={props.errorType? errorRetryMessage[props.errorType] :'B031-1'}/></S.Retry>, br: <br/>}}/>
      </S.P>
      <S.Button as="a" href={props.errorType? errorRedirectURL[props.errorType] :'/home'}><FormattedMessage id={props.errorType? errorRedirectButtonName[props.errorType]: 'B032'}/></S.Button>
    </S.Container>
  )
}

export { ErrorPage as default };
